import { FC } from 'react';

interface IProps {
  title: string;
  color?: string;
  mt?: string;
  mb?: string;
  textSize?: string;
}

const Label: FC<IProps> = ({
  title,
  color = '#777777',
  mt = '0px',
  mb = '0px',
  textSize = '12px',
}) => {
  return <div className={`text-[${textSize}] text-[${color}] mt-[${mt}] mb-[${mb}]`}>{title}</div>;
};

export default Label;
